<template>
  <div>
    <v-row class="pr-2 pl-2" no-gutters>
      <v-col justify="start" cols="2">
        <v-select v-model="selectedClientId" :items="clientList" item-text="name" item-value="clientId"
          label="Client"></v-select>
      </v-col>
      <v-col justify="end" cols="3" class="offset-2">
        <v-menu ref="menu_startDateTime" v-model="startDateTimeMenu" :close-on-content-click="true"
          transition="scale-transition" offset-y max-width="290px" min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="startDateTime" label="Start Date" prepend-icon="mdi-calendar" v-bind="attrs"
              v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="startDateTime" no-title @input="startDateTimeMenu = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col justify="end" cols="3">
        <v-menu ref="menu_endDateTime" v-model="endDateTimeMenu" :close-on-content-click="true"
          transition="scale-transition" offset-y max-width="290px" min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="endDateTime" label="End Date" prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" />
          </template>
          <v-date-picker v-model="endDateTime" no-title @input="endDateTimeMenu = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col justify="end" cols="2">
        <v-btn tile color="primary" @click="loadAllStrategyReports()" :disabled="anyReportLoading">
          Update
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="pb-3 bottom-spacing" no-gutters>
      <v-col cols="12">
        <div class="ma-2">
          <v-row class="elevation-3 pl-4 wz_table_header" no-gutters>
            <h2 class="pb-4 pt-4">{{ this.getReportHeader("strategyTotals2") }}</h2>
          </v-row>
          <v-data-table disable-filtering :hide-default-footer="true" disable-sort class="wz_data_table elevation-2"
              :loading="!reports.strategyTotals2.loaded" :headers="strategyTotalsReportHeaders"
              :items="strategyTotalsReportDataWithCampaigns" :item-class="strategyTotalRowClass" item-key="name"
              @click:row="loadCampaignData" />
            <v-row>
              <v-col cols="12" class="mt-1">
                <v-btn @click="exportStrategyReports(reports.strategyTotals2)" text color="primary">Export to Excel</v-btn>
              </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col v-if="selectedCampaignId" cols="12" class="mt-3 mb-3">
        <v-divider light />
      </v-col>
      <v-col v-if="reports.strategyCampaignDevices.active" cols="12" class="mb-3">
        <div class="ma-2">
          <v-row class="elevation-3 pl-4 wz_table_header" no-gutters>
            <h2 class="pb-4 pt-4">
              {{ this.getReportHeader("strategyCampaignDevices") }}
            </h2>
          </v-row>
          <v-data-table disable-filtering :hide-default-footer="true" disable-sort class="wz_data_table elevation-2"
            :loading="!reports.strategyCampaignDevices.loaded" :headers="headers[reports.strategyCampaignDevices.name]"
            :items="reportData[reports.strategyCampaignDevices.name]" item-key="name" />
          <v-row>
            <v-col cols="12" class="mt-1">
              <v-btn @click="exportStrategyReports(reports.strategyCampaignDevices)" text color="primary">Export to
                Excel</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col v-if="reports.strategyCampaignReferrers.active" cols="12">
        <div class="ma-2">
          <v-row class="elevation-3 pl-4 wz_table_header" no-gutters>
            <h2 class="pb-4 pt-4">
              {{ this.getReportHeader("strategyCampaignReferrers") }}
            </h2>
          </v-row>
          <v-data-table disable-filtering :hide-default-footer="true" disable-sort class="wz_data_table elevation-2"
            :loading="!reports.strategyCampaignReferrers.loaded"
            :headers="headers[reports.strategyCampaignReferrers.name]"
            :items="reportData[reports.strategyCampaignReferrers.name]" item-key="name" />
          <v-row>
            <v-col cols="12" class="mt-1">
              <v-btn @click="exportStrategyReports(reports.strategyCampaignReferrers)" text color="primary">
                Export to Excel
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col v-if="reports.strategyCampaignCTs.active" cols="12">
        <div class="ma-2 mb-10">
          <v-row class="elevation-3 pl-4 wz_table_header" no-gutters>
            <h2 class="pb-4 pt-4">
              {{ this.getReportHeader("strategyCampaignCTs") }}
            </h2>
          </v-row>
          <v-data-table disable-filtering :hide-default-footer="true" disable-sort class="wz_data_table elevation-2"
            :loading="!reports.strategyCampaignCTs.loaded" :headers="strategyCampaignCTsReportHeaders"
            :items="strategyCampaignCTsReportDataWithWidgets" item-key="name" />
          <v-row>
            <v-col cols="12" class="mt-1">
              <v-btn @click="exportStrategyReports(reports.strategyCampaignCTs)" text color="primary">
                Export to Excel
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import api from "../services/support.api";
import { json2excel } from "js2excel";

export default {
  data: () => {
    return {
      anyReportLoading: false,
      startDateTimeMenu: false,
      endDateTimeMenu: false,
      reports: {
        strategyTotals2: {
          name: "strategyTotals2",
          heading: "Strategy Totals",
          loaded: false,
          showTotal: true,
          cols: 33,
          active: true,
        },
        strategyCampaignDevices: {
          name: "strategyCampaignDevices",
          heading: "Devices",
          loaded: false,
          showTotal: true,
          cols: 33,
          active: false,
        },
        strategyCampaignReferrers: {
          name: "strategyCampaignReferrers",
          heading: "Strategy Campaign Referrers",
          loaded: false,
          showTotal: true,
          cols: 33,
          active: false,
        },
        strategyCampaignCTs: {
          name: "strategyCampaignCTs",
          heading: "Conversion Tools",
          loaded: false,
          showTotal: true,
          cols: 14,
          active: false,
        },
      },
      selectedClientId: 61,
      selectedclientIdChanged: false,
      startDateTime: new Date().toISOString().substr(0, 10),
      endDateTime: new Date().toISOString().substr(0, 10),
      clientList: [{ name: "Lead Forensics", id: 61 }],
      reportData: {
        strategyTotals2: [],
        strategyCampaignDevices: [],
        strategyCampaignCTs: [],
        strategyCampaignReferrers: [],
      },
      headers: {
        strategyTotals2: [],
        strategyCampaignDevices: [],
        strategyCampaignCTs: [],
        strategyCampaignReferrers: [],
      },
      campaigns: [],
      widgets: [],
      selectedCampaignId: null,
    };
  },
  methods: {
    async getReport(key, clientCampaignId) {
      this.anyReportLoading = true;
      this.reportData[key] = [];
      this.reports[key].loaded = false;

      const report = await api.getReport(
        key,
        this.selectedClientId,
        this.startDateTime,
        this.endDateTime,
        clientCampaignId
      );
      this.reportData[key] = report.data;
      this.headers[key] = report.columns;

      this.reports[key].loaded = true;
      this.anyReportLoading = false;
    },
    async loadAllStrategyReports() {
      this.resetReportData();
      if (this.selectedclientIdChanged) {
        await this.getCampaigns(this.selectedClientId);
        await this.getWidgets(this.selectedClientId);
        this.selectedclientIdChanged = false;
      }
      const getReportPromises = Object.values(this.reports)
        .filter(r => r.active)
        .map(r => r.name)
        .map(name => this.getReport(name, this.selectedCampaignId));

      Promise.all(getReportPromises);
    },
    async getClientList() {
      let c = await api.getClientList();
      this.clientList = [
        ...(c.filter((x) => !x.disabled)).sort((a, b) => a.name.localeCompare(b.name)),
        ...(c.filter((x) => x.disabled)).sort((a, b) => a.name.localeCompare(b.name)),
      ];
    },
    loadCampaignData(value) {
      const campaignId = value.CAMPAIGN_ID;

      this.selectedCampaignId = campaignId;
      this.getReport(this.reports.strategyCampaignDevices.name, campaignId);
      this.getReport(this.reports.strategyCampaignReferrers.name, campaignId);
      this.getReport(this.reports.strategyCampaignCTs.name, campaignId);

      this.reports.strategyCampaignDevices.active = true;
      this.reports.strategyCampaignReferrers.active = true;
      this.reports.strategyCampaignCTs.active = true;
    },

    async getCampaigns(clientId) {
      this.campaigns = await api.getClientCampaigns(clientId, false);
    },
    async getWidgets(clientId) {
      this.widgets = await api.getClientWidgets(clientId);
    },
    reportDataForExport(name) {
      let exportHeaders = [...this.headers[name]];
      let exportData = this.reportData[name];
      if (name === 'strategyTotals2') {
        exportData = this.strategyTotalsReportDataWithCampaigns;
        exportHeaders = exportHeaders.filter((x) => x.value !== 'CAMPAIGN_ID');
        exportHeaders.unshift({ text: 'Strategy', value: 'CAMPAIGN_NAME' });
      } else if (name === 'strategyCampaignCTs') {
        exportData = this.strategyCampaignCTsReportDataWithWidgets;
        exportHeaders = exportHeaders.filter((x) => x.value !== 'WIDGET_ID');
        exportHeaders.unshift({ text: 'Conversion Tool', value: 'WIDGET_NAME' });
      }
      return exportData.map((x) => {
        const l = {};
        for (let i = 0; i < exportHeaders.length; i += 1) {
          const h = exportHeaders[i];
          l[h.text] = x[h.value];
        }
        return l;
      });
    },
    exportStrategyReports(report) {
      json2excel({
        data: this.reportDataForExport(report.name),
        name: this.getReportHeader(report.name).substring(0, 31),
      });
    },
    resetReportData() {
      this.reportData = {
        strategyTotals2: [],
        strategyCampaignDevices: [],
        strategyCampaignCTs: [],
        strategyCampaignReferrers: [],
      };
    },
    getReportHeader(name) {
      if (name === 'strategyTotals2') {
        return `${this.reports.strategyTotals2.heading} - ${this.clientName}`;
      }
      return `${this.reports[name].heading} (${this.campaignName})`
    },
    strategyTotalRowClass(row) {
      return this.selectedCampaignId === row.CAMPAIGN_ID ? 'row-selected' : '';
    }
  },
  computed: {
    strategyTotalsReportDataWithCampaigns() {
      if (this.reportData.strategyTotals2.length === 0 || this.campaigns.length === 0) {
        return [];
      }

      return this.reportData.strategyTotals2.map((record) => {
        const campaignId = record.CAMPAIGN_ID;
        const selectedCampaign = this.campaigns.find((campaign) => campaign.clientCampaignId === campaignId);
        const campaignName = selectedCampaign ? selectedCampaign.name : campaignId;

        return {
          ...record,
          CAMPAIGN_NAME: campaignName
        }
      });
    },

    strategyTotalsReportHeaders() {
      if (this.headers.strategyTotals2.length === 0) {
        return [];
      }

      const reportHeadersCopy = [...this.headers.strategyTotals2];
      reportHeadersCopy.unshift({
        text: "Strategy",
        value: "CAMPAIGN_NAME",
      });
      return reportHeadersCopy;
    },

    strategyCampaignCTsReportDataWithWidgets() {
      if (!this.reportData.strategyCampaignCTs.length || !this.widgets.length) {
        return [];
      }

      return this.reportData.strategyCampaignCTs.map((record) => {
        const recordWidgetId = record.WIDGET_ID;

        const selectedWidget = this.widgets.find((x) => x.clientWidgetId === recordWidgetId);
        const widgetName = selectedWidget ? selectedWidget.name : recordWidgetId;
        return {
          ...record,
          WIDGET_NAME: widgetName,
        };
      });
    },

    strategyCampaignCTsReportHeaders() {
      if (!this.headers.strategyTotals2.length) {
        return [];
      }
      const strategyCampaignCTs = [...this.headers.strategyCampaignCTs]
      strategyCampaignCTs.unshift({
        text: "Conversion Tool",
        value: "WIDGET_NAME",
      });
      return strategyCampaignCTs;
    },
    campaignName() {
      return this.campaigns.find(
        (campaign) => campaign.clientCampaignId === this.selectedCampaignId
      ).name;
    },
    clientName() {
      const selectedClient = this.clientList.find(
        (client) => client.clientId === this.selectedClientId
      )

      return selectedClient ? selectedClient.name : '';
    }
  },
  async mounted() {
    await this.getClientList();
    await this.getCampaigns(this.selectedClientId);
    await this.getWidgets(this.selectedClientId);
    await this.getReport(this.reports.strategyTotals2.name);
  },
  watch: {
    async selectedClientId() {
      this.selectedclientIdChanged = true;
      this.reports.strategyCampaignDevices.active = false;
      this.reports.strategyCampaignReferrers.active = false;
      this.reports.strategyCampaignCTs.active = false;

      await this.getCampaigns(this.selectedClientId);
      await this.getWidgets(this.selectedClientId);
      this.getReport(this.reports.strategyTotals2.name);
    },
  },
};
</script>

<style>
.wz_data_table td {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 400px !important;
}

.wz_data_table {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  height: calc(100% - 68px);
}

.wz_table_header {
  background-color: #edf3fb;
  color: #424242;
  height: 68px;
}

.text-start {
  overflow-wrap: unset;
}

.bottom-spacing {
  margin-bottom: 150px !important;
}

.row-selected {
  background-color: #447BBD;
  color: white;
}
</style>
